import {
  create,
  type DescMessage,
  type DescMethodUnary,
  type MessageInitShape,
  type MessageShape,
} from '@bufbuild/protobuf';
import { type ContextValues, type Transport } from '@connectrpc/connect';

/**
 * This is a thin wrapper around the original callUnaryMethod function from connect-query-core,
 * which allows to pass contextValues in options.
 *
 * @see https://github.com/connectrpc/connect-query-es/blob/main/packages/connect-query-core/src/call-unary-method.ts
 */
export async function callUnaryMethod<I extends DescMessage, O extends DescMessage>(
  transport: Transport,
  schema: DescMethodUnary<I, O>,
  input: MessageInitShape<I> | undefined,
  options?: {
    signal?: AbortSignal;
    headers?: HeadersInit;
    contextValues?: ContextValues;
    // Per-call deadline override; falls back to the transport's `defaultTimeoutMs` when unset.
    timeoutMs?: number;
  },
): Promise<MessageShape<O>> {
  const result = await transport.unary(
    schema,
    options?.signal,
    options?.timeoutMs,
    options?.headers,
    input ?? create(schema.input),
    options?.contextValues,
  );
  return result.message;
}
